export var EPIC_END = '@@redux-most/EPIC_END';
export var STATE_STREAM_SYMBOL = Symbol('@@redux-most/STATE_STREAM');